'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('AreaTemplateCtrl', AreaTemplateCtrl);

  AreaTemplateCtrl.$inject = ['$scope', 'constants', '$location', '$window', 'technicalElements',
    'areaTemplates', 'AreaTemplateAPI', 'Labels', '$mdDialog', 'SimpleDialogFormService'];

  function AreaTemplateCtrl ($scope, constants, $location, $window, technicalElements,
    areaTemplates, AreaTemplateAPI, Labels, $mdDialog, SimpleDialogFormService) {

    const vm = this;

    vm.$onInit = function () {
      vm.config = {
        maxChars: 30 // Changes based on screen width
      };

      vm.LABELS = Labels;
      vm.selected = {};

      vm.modules = technicalElements;
      vm.isLoading = true;

      update();
    };

    function update (templates = areaTemplates) {
      vm.areaTemplates = templates;
      vm.model = {
        qualityLevels: constants.QUALITY_LEVELS,
        areaCategories: []
      };

      // first walk trough all parents (categories)
      templates.forEach((areatemplate) => {
        if (areatemplate.isParent) {
          areatemplate.areaTypes = [];
          vm.model.areaCategories.push(areatemplate);
        }
      });

      // then the children..
      templates.forEach((areatemplate) => {
        if (!areatemplate.isParent) {
          const parent = vm.model.areaCategories.find((category) => category._id === areatemplate.parentId);
          if (parent) {
            parent.areaTypes.push(areatemplate);
          }
        }
      });

      if (vm.model.areaCategories.length > 0) {
        vm.selectTemplate(vm.model.areaCategories[0]._id);
      } else {
        vm.isLoading = false;
      }
    }


    /* ========================================================================
     =================================== HELPERS ===============================
     ======================================================================== */

    const onResize = function onResize () {
      if (vm.config.viewWidth !== $window.innerWidth) {
        // change maxChars dynamically depending on viewWidth
        if ($window.innerWidth < 768) {
          vm.config.maxChars = 100;
        } else if ($window.innerWidth < 1220) {
          vm.config.maxChars = 45;
        } else {
          vm.config.maxChars = ($window.innerWidth - 480) / 25;
        }

        // digest
        $scope.$digest();
      }
    };

    const cleanUp = function cleanUp () {
      angular.element($window).off('resize', onResize);
    };

    vm.selectTemplate = function (areaTemplateId) {
      const areatemplate = vm.areaTemplates.find((template) => template._id === areaTemplateId);

      areatemplate.modules = vm.modules.map((module) => {
        module.submodules = module.submodules.map((submodule) => {
          submodule.elements = submodule.elements.map((element) => {
            // [{techElementId: 2, quality "A", value: 666}, {techElementId: 2, ...}]
            const areaElementValues = areatemplate.values.filter((value) => value.techElementId === element._id);

            element.values = {};
            constants.QUALITY_LEVELS.forEach((qualityLevel) => {
              const qualityLevelValue = areaElementValues.find((value) =>
                value.quality === qualityLevel.value);

              element.values[qualityLevel.value] = qualityLevelValue ? qualityLevelValue.value : null;
            });

            return element;
          });
          return submodule;
        });
        return module;
      });

      vm.selected.areatemplate = areatemplate;
      vm.isLoading = false;

      vm.model.moduleOptions = [];
      vm.model.groupOptions = [];
      vm.model.elementOptions = [];

      vm.model.moduleOptions.push({name: Labels.getLabel('cleardata'), action: 'remove', icon: 'delete_sweep'});
      vm.model.groupOptions.push({name: Labels.getLabel('cleardata'), action: 'remove', icon: 'delete_sweep'});
      vm.model.elementOptions.push({name: Labels.getLabel('cleardata'), action: 'remove', icon: 'delete_sweep'});

      if (!areatemplate.isParent) {
        vm.model.moduleOptions.push({name: Labels.getLabel('copycategorydata'), action: 'copy', icon: 'file_copy'});
        vm.model.groupOptions.push({name: Labels.getLabel('copycategorydata'), action: 'copy', icon: 'file_copy'});
        vm.model.elementOptions.push({name: Labels.getLabel('copycategorydata'), action: 'copy', icon: 'file_copy'});
      }
    };

    vm.getSelectedTitle = function () {
      if (angular.isUndefined(vm.selected.areatemplate) ||
        vm.selected.areatemplate === null ||
        vm.selected.areatemplate === {}) {
        return '';
      }
      return vm.selected.areatemplate.name;
    };

    function typecast (type, value) {
      // TODO
      return value;
    }


    // INTERACTION (EVENT) HANDLERS

    vm.submitValue = function (input, qualityLevel, immediateValue) {
      const fieldObj = {
        techElementId: input._id,
        quality: qualityLevel.value,
        value: typecast(input.type, immediateValue)
      };
      const saveFieldObj = {field: fieldObj, _id: vm.selected.areatemplate._id};

      AreaTemplateAPI.saveField(saveFieldObj).$promise.then(function () {
        const fieldToUpdate = vm.selected.areatemplate.values.find((value) =>
          value.techElementId === fieldObj.techElementId && value.quality === fieldObj.quality);

        if (!fieldToUpdate) {
          vm.selected.areatemplate.values.push(fieldObj);
        } else {
          fieldToUpdate.value = fieldObj.value;
        }

        vm.selectTemplate(saveFieldObj._id);
      });
    };

    vm.openAreaTemplateModal = (ev, optionalAreaTemplate) => {

      $mdDialog.show({
        scope: $scope.$new(),
        preserveScope: false,
        controller: 'EditAreaTemplateCtrl',
        controllerAs: '$EditAreaTemplateCtrl',
        locals: {
          areaTemplates: vm.areaTemplates,
          model: optionalAreaTemplate,
        },
        bindToController: true,
        templateUrl: 'app-legacy/area_template/edit-area-template/edit-area-template-dialog.tmpl.html',
        targetEvent: ev
      }).then((updatedTemplates) => {
        update(updatedTemplates);
      }).catch(() => {
      });
    };

    vm.onToggleCollapse = function (areatemplate) {
      areatemplate.isCollapsed = !areatemplate.isCollapsed;
    };

    // module item actions
    vm.doItemActionFor = function (structureLevel, item, action) {
      const args: any = {};

      args.id = vm.selected.areatemplate._id;

      if (structureLevel === 'techelement') {
        args.techElementId = item._id;
      }

      if (structureLevel === 'module') {
        args.moduleId = item._id;
      }

      if (structureLevel === 'submodule') {
        args.submoduleId = item._id;
      }

      if (action === 'copy') {
        AreaTemplateAPI.copyField(args).$promise.then(function (updatedTemplate) {
          updateModel(updatedTemplate);
        });
      }

      if (action === 'remove') {
        AreaTemplateAPI.clearField(args).$promise.then(function (updatedTemplate) {
          updateModel(updatedTemplate);
        });
      }
    };

    function updateModel (updatedTemplate) {
      vm.areaTemplates = areaTemplates.map((template) => {
        if (template._id === updatedTemplate._id) {
          return updatedTemplate;
        }
        return template;
      });

      vm.selectTemplate(updatedTemplate._id);
    }

    vm.confirmDeleteAreaTemplate = function (ev, areatemplate) {
      let options = {
        title: Labels.getLabel('deleteareatemplate'),
        content: Labels.getLabel('areyousuredeletingareatemplate'),
        ok: Labels.getLabel('delete'),
        cancel: Labels.getLabel('cancel')
      };

      SimpleDialogFormService.confirm(ev, options, areatemplate).then(() => deleteAreaTemplate(areatemplate)).catch(() => {
      });
    };

    function deleteAreaTemplate (areatemplate) {
      // $log.debug('soft deleting areatemplate id: ', areatemplate._id)
      AreaTemplateAPI.delete({id: areatemplate._id}).$promise
        .then(function (updatedAreaTemplates) {
          update(updatedAreaTemplates);
        });
    };

    /* ========================================================================
     ================================== IMMEDIATE ==============================
     ======================================================================== */

    angular.element($window).on('resize', onResize);
    $scope.$on('$destroy', cleanUp);
  }

})();
